import path from 'path';

import { IdReference, OffsetPagedResults } from '~interfaces';
import { GeneralPagedParameters } from '~interfaces/requests';
import { BaseReferenceResponse, PagedResponse } from '~interfaces/responses';
import { TopologyService } from '~services';

import ApprovalStateEnum from '../enums/approvalStateEnum';
import BookingStatusEnum from '../enums/bookingStatusEnum';
import UsageStateEnum from '../enums/usageStateEnum';
import Booking, { BookingNew } from '../interfaces/booking';

class BookingsV2Service extends TopologyService {
	public readonly path = 'bookings';

	constructor() {
		super('v2');
	}

	/**
	 * Create a new booking
	 * @param data
	 * @returns
	 */
	async createBooking(data: BookingNew): Promise<IdReference> {
		const content = BookingsV2Service.toRequest(data);

		const response = await this._client.post(this.path, content);

		return response.data;
	}

	static fromResponse(data: BookingResponse): Booking {
		const { id, name, start, end, hub, instance, user, ...rest } = data;

		return {
			...rest,
			...BookingsV2Service.fromBaseReferenceResponse({
				id: id,
				name: name,
			}),
			period: {
				start: new Date(start),
				end: new Date(end),
			},
			user: BookingsV2Service.fromBaseReferenceResponse(user),
			item: BookingsV2Service.fromBaseReferenceResponse(instance),
			hub: BookingsV2Service.fromBaseReferenceResponse(hub),
		};
	}

	static toRequest(data: BookingNew): BookingRequest {
		const { user, itemGroup, item, period, ...rest } = data;

		return {
			userId: user.id,
			itemId: itemGroup.id,
			itemInstanceId: item?.id,
			periodStart: period.start?.toISOString(),
			periodEnd: period.end.toISOString(),
			ignoreMaintenance: true,
			...rest,
		};
	}
}

interface BookingResponse extends BaseReferenceResponse {
	status: BookingStatusEnum;
	approvalState: ApprovalStateEnum;
	usageState: UsageStateEnum;
	attentionStates: string[];
	billingType: 'personal' | 'business';
	price: 'todo';
}

interface BookingRequest {
	userId: string;
	itemId?: string;
	itemInstanceId?: string;
	periodStart?: string;
	periodEnd: string;
	billingType: 'personal' | 'business';
	discount?: number;
	comment?: string;
	ignoreMaintenance?: boolean;
	promoCode?: string;
}

export default BookingsV2Service;
